module.exports = __webpack_public_path__ + "img/T4-B-rc_11.3aa27aa7.png";